export const BLOGCATEGORIES_ARRAY = [
  ["Przepisy", "legal"],
  ["Zarobki", "earnings"],
  ["Kierowca zawodowy", "driver"],
  ["Eco", "eco"],
  ["Ciekawoski", "news"],
  ["AI", "ai"],
  ["Zdrowie", "health"],
]
